/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imagepane/loading/loading_styles';



/* ========== ~~~~~~~~~~ IMAGE PANE : LOADING ~~~~~~~~~~ ========== */
class Loading extends Component {
	render() {
		let { images, error, yourown } = this.props;
		return <div className={`loading ${this.props.classes.loading}`} >
			{error ? <p>Sorry, an error occurred while retrieving images.</p> : (images ? (yourown ? null : <p>Sorry, no results were found.</p>) : <img src="https://cdn-images-1.medium.com/max/1600/1*9EBHIOzhE1XfMYoKz1JcsQ.gif" alt="" />)}
		</div>
	};
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Loading);
